import { SellerSkillItem } from '@gumtree/shared/src/model/listing.model';

export const UPDATE_SELLER_SKILLS_LIST = 'UPDATE_SELLER_SKILLS_LIST';

export const updateSellerSkillsList = (payload: SellerSkillItem[]) => ({
    type: UPDATE_SELLER_SKILLS_LIST,
    payload,
});

export default (state = [] as SellerSkillItem[], action: ReturnType<typeof updateSellerSkillsList>) =>
    action.type === UPDATE_SELLER_SKILLS_LIST ? action.payload : state;
